import React from 'react';

interface StoreGateProps {
  children: React.ReactNode;
}

export const StoreGate: React.FC<StoreGateProps> = ({ children }) => {
  return <>{children}</>;
}; 